import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-cancel-dialog",
  standalone: false,
  templateUrl: "./cancel-dialog.component.html",
  styleUrl: "./cancel-dialog.component.css",
})
export class CancelDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CancelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  continue() {
    this.dialogRef.close(false);
  }

  Discard() {
    this.dialogRef.close(true);
    //  this.router.navigate(['question/list-rubric']);
  }
}
